import { jsx as _jsx } from "react/jsx-runtime";
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { Loader } from '@design-system/loader';
export const IMAGE_TYPE = 'image';
export const VIDEO_TYPE = 'video';
export const isFileAnImage = (type) => Boolean(type === null || type === void 0 ? void 0 : type.includes(IMAGE_TYPE));
export const isFileAVideo = (type) => Boolean(type === null || type === void 0 ? void 0 : type.includes(VIDEO_TYPE));
export const AttachedIcon = ({ error, loading, size, type, }) => {
    const height = size === 'small' ? '20px' : '28px';
    if (error) {
        return (_jsx(FontAwesomeIcon, { color: "primary", height: height, iconName: "file-exclamation", iconType: CATEGORIES.DUOTONE }));
    }
    if (loading) {
        return _jsx(Loader, { size: 30 });
    }
    if (isFileAnImage(type)) {
        return (_jsx(FontAwesomeIcon, { color: "primary", height: height, iconName: "image", iconType: CATEGORIES.DUOTONE }));
    }
    if (isFileAVideo(type)) {
        return (_jsx(FontAwesomeIcon, { color: "primary", height: height, iconName: "circle-play", iconType: CATEGORIES.DUOTONE }));
    }
    return (_jsx(FontAwesomeIcon, { color: "primary", height: height, iconName: "file-lines", iconType: CATEGORIES.DUOTONE }));
};
//# sourceMappingURL=AttachedIcon.js.map